export default __webpack_public_path__ + "static/media/strategik2.28397612.jpg";